import { Icon } from '@iconify/react';
//import appleFilled from '@iconify/icons-ant-design/apple-filled';
import facebookFilled from '@iconify/icons-ant-design/facebook-filled';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Stack, Typography } from '@material-ui/core';
import { fShortenNumber } from '../../utils/formatNumber';
// utils
// ----------------------------------------------------------------------


const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  // textAlign: 'center',
  fontWeight: 'bold',
  padding: theme.spacing(2, 0, 2, 2),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '50%',
  width: theme.spacing(6),
  height: theme.spacing(6),
  justifyContent: "center",
  //marginBottom: theme.spacing(2),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

const COLOR_SELECTED = {
  facebook: "#74ccf4"
}
// ----------------------------------------------------------------------

const TOTAL = 1352831;

export default function AnalyticsNewUsers({ value, title, channelSelected }) {
  return (
    <RootStyle sx={{ border: channelSelected ? '2px solid ' + COLOR_SELECTED[channelSelected] : 'none', }}>
      <Typography fontWeight={"bold"} variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
      <Stack direction={"row"} spacing={2} sx={{ marginTop: 1 }}>
        <IconWrapperStyle>
          <Icon style={{ alignSelf: "center", color: channelSelected === "facebook" ? null : "grey" }} icon={facebookFilled} width={channelSelected === "facebook" ? 40 : 32} height={channelSelected === "facebook" ? 48 : 32} />
        </IconWrapperStyle>
        {/* <Typography alignSelf={"center"} variant="h3">{fShortenNumber(value)}</Typography> */}
        <Typography alignSelf={"center"} variant="h3">{value}</Typography>
      </Stack>
    </RootStyle>
  );
}
